const { USE_OLD_STORAGE_SETTINGS } = require("../../constants/cookies");
const { getAbTestVariantNew } = require("../new-ab-tests/new-ab-tests-service");
const { BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES, NEW_CRM_PRICING_TEST, CRM_PRICING_NO_BASIC_TEST, SUNSET_BASIC_TIER_IN_WM_HP_AB_TEST, CRM_PRICING_NO_SEATS_TEST, HOMEPAGE_GOOGLE_ONE_TAP_TEST } = require("../../constants/new-ab-tests");
const { trackEvent } = require("services/bigbrain-service");
const { SUNSET_BASIC_TIER_TEST_ALLOCATION } = require("constants/bigbrain-event-types");
const { CRM_PRODUCT_ID } = require("constants/products");
const shouldShowBiggerStorageInPricingFeatures = (abTests = [], cookies = {}, sendBigBrainEvent = false)=>{
    if (typeof cookies[USE_OLD_STORAGE_SETTINGS] !== "undefined") {
        return cookies[USE_OLD_STORAGE_SETTINGS] !== "true";
    }
    return getAbTestVariantNew(abTests, BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.test_name, sendBigBrainEvent) === BIGGER_STORAGE_IN_PRICING_PAGE_FEATURES.new_variation_name;
};
const shouldShowNewCrmPricingTest = (abTests = [], sendBigBrainEvent = false)=>{
    return getAbTestVariantNew(abTests, NEW_CRM_PRICING_TEST.test_name, sendBigBrainEvent) === NEW_CRM_PRICING_TEST.variant_a;
};
const shouldShowCrmPricingNoBasicTest = (abTests = [], sendBigBrainEvent = false)=>{
    return getAbTestVariantNew(abTests, CRM_PRICING_NO_BASIC_TEST.test_name, sendBigBrainEvent) === CRM_PRICING_NO_BASIC_TEST.variant_a;
};
const shouldSunsetBasicTierWMTest = (abTests = [], sendBigBrainEvent = false)=>{
    const testVariant = getAbTestVariantNew(abTests, SUNSET_BASIC_TIER_IN_WM_HP_AB_TEST.test_name, sendBigBrainEvent);
    trackEvent(SUNSET_BASIC_TIER_TEST_ALLOCATION, {
        data: {
            account_allocation: testVariant,
            test_name: SUNSET_BASIC_TIER_IN_WM_HP_AB_TEST.test_name,
            new_variation_name: SUNSET_BASIC_TIER_IN_WM_HP_AB_TEST.new_variation_name
        }
    });
    return testVariant === null ? null : testVariant === SUNSET_BASIC_TIER_IN_WM_HP_AB_TEST.new_variation_name;
};
const shouldShowEnterpriseToUltimateRename = (product)=>{
    return product === CRM_PRODUCT_ID;
};
const shouldHideCrmSeatsSelection = (abTests = [], sendBigBrainEvent = false)=>{
    return getAbTestVariantNew(abTests, CRM_PRICING_NO_SEATS_TEST.test_name, sendBigBrainEvent) === CRM_PRICING_NO_SEATS_TEST.new_variation_name;
};
const shouldShowHomepageGoogleOneTap = (abTests = [], sendBigBrainEvent = false)=>{
    return getAbTestVariantNew(abTests, HOMEPAGE_GOOGLE_ONE_TAP_TEST.test_name, sendBigBrainEvent) === HOMEPAGE_GOOGLE_ONE_TAP_TEST.new_variation_name;
};
module.exports = {
    shouldShowBiggerStorageInPricingFeatures,
    shouldShowNewCrmPricingTest,
    shouldShowCrmPricingNoBasicTest,
    shouldSunsetBasicTierWMTest,
    shouldShowEnterpriseToUltimateRename,
    shouldHideCrmSeatsSelection,
    shouldShowHomepageGoogleOneTap
};
